module.exports = __webpack_public_path__ + "img/text-mark5.5933cb83.png";